export default __webpack_public_path__ + "b4dc30edeabb77d490be9c5ed6fe9dbc.svg";